<template>
  <div id="app">
    <!-- 主路由出口 -->
    <Layout></Layout>

    <!-- 第三方 阿里云呼叫中心 -->
    <div id="CallCenter"></div>
    <!--样本库电话回拨系统-->
    <div id="callBackProcess">
      <receive-caller></receive-caller>
      <MyFeedback></MyFeedback>
    </div>
  </div>
</template>

<script>
import receiveCaller from './components/callerBackModals/receiveCaller'
import {mapGetters, mapMutations} from "vuex";
import MyFeedback from './components/common/MyFeedback.vue'
import Layout from './components/common/Layout.vue'

export default {
  name: 'app',
  data() {
    return {}
  },
  components: {
    receiveCaller, MyFeedback, Layout
  },
  computed: {
    ...mapGetters(["isCallOnly"])
  },
  methods: {
    ...mapMutations({
      setContactId: 'setContactId'
    }),

  },
  created() {
    console.log(this.$router.path);
    // if(this.$router.path != '/login') {
    //     setTimeout(() => {
    //         this.watermark()
    //     },300)
    // }
  },
  mounted() {
    let vm = this;
    window.pubsub && window.pubsub.on('call-applyForCallOnly', () => {
      if (window.workbench.getStatusCode().code == 3) {
        console.log("设置是否允许外呼允许外呼", vm.isCallOnly)
        window.workbench && window.workbench.applyForCallOnly(vm.isCallOnly)
      }
    });

    console.log("path===>", this.$route.path);
    localStorage.removeItem('setWater')
  }
}
</script>


<style lang="scss">
#app {
  font-family: PingFangSC-Regular,'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  font-size: 16px;
  height: 100vh;
  .el-header {
    height: 60px !important;
  }

  #callBackProcess {
  }

  h2 {
    line-height: 25px !important;
  }
}
.el-container {
  height: 100vh !important;
}
.el-backtop {
  position: absolute !important;
  z-index: 99999 !important;
}
</style>
